import type { LaptopHelperStepProps } from '../Steps'

export const ExampleStep2 = ({}: LaptopHelperStepProps) => {
  return <div>Example Step 2</div>
}
